<template>
  <div class="payment-view">
    <navbar class="mb-5 navbar-fixed"/>
    <div class="page-content payment-page-content">
      <progress
          v-if="AppStoreStore && AppStoreStore.loading"
          class="progress is-primary is-small mt-6"
          max="100"
      ></progress>
      <div class="columns my-6 mx-0 no-overflow">
        <div class="column is-12 px-2-mobile">
          <div class="container no-overflow">
            <div class="columns mt-3 no-overflow">
              <div class="column is-6 is-full-mobile">
                <p class="is-size-1 is-size-3-mobile has-text-left has-text-primary dm-sans has-text-weight-bold">
                  PAGAMENTO
                </p>
              </div>
            </div>
            <div class="columns is-multiline no-overflow" v-if="orderFormData">
              <div class="column is-6 is-full-mobile">
                <review-box :formData="orderFormData"></review-box>
              </div>
              <div class="column is-6 is-full-mobile">
                <div class="steps-container">
                  <steps
                    ref="paymentSteps"
                    :formData="orderFormData"
                  >
                    <template>
                      <tab name="Modalidade" :selected="true">
                        <div id="form-step-1">
                          <credit-card-payment
                            :formData="orderFormData"
                            @nextTab="nextTab"
                          ></credit-card-payment>
                        </div>
                      </tab>
                      <tab name="Setup/Serviços"></tab>
                    </template>
                  </steps>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ReviewBox from "@/components/Billet/ReviewBox"
import CreditCardPayment from "@/components/Payment/Tabs/CreditCardPayment"
import Navbar from "@/components/Wizard/Navbar"
import Steps from "@/components/Payment/Steps/Index"
import Tab from "@/components/Payment/Tab"
import { useAppStore } from "@/stores/AppStore"
import { mapStores } from 'pinia'

export default {
  name: 'payment',

  components: {
    CreditCardPayment,
    ReviewBox,
    Navbar,
    Steps,
    Tab
  },

  // data() {
  //   return {
  //     orderType: 'credit_card',
  //     orderFormData: {"partner":{"showStep":true,"data":{"id":1,"name":"Febrafar","plans":[{"id":5,"name":"Anual","max_users":"Ilimitados","functionalities":"TODAS AS ATUAIS","seasonality":12,"price":"209.9","setup_price":"299.9","integration_plan_id":"68669","integration_plan_product_id":"185715","integration_setup_id":"185716","discount_percentage":40}]},"hasSum":true},"plan":{"showStep":true,"unit":"mês","data":{"id":5,"name":"Anual","max_users":"Ilimitados","functionalities":"TODAS AS ATUAIS","seasonality":12,"price":"209.9","setup_price":"299.9","integration_plan_id":"68669","integration_plan_product_id":"185715","integration_setup_id":"185716","discount_percentage":40,"messagePackets":[{"id":1,"price":"129.9","mode":2,"integration_id":"185719"},{"id":2,"price":"0.01","mode":1,"integration_id":null}],"partners":[{"id":1,"name":"Febrafar"}],"extraServicePlans":[{"id":20,"plan_id":5,"extra_service_id":13,"extraService":{"id":13,"name":"Curadoria de Disparos","price":"100","type":2,"seasonality":12,"integration_id":"186505","unit_of_measurement":"/ano"}},{"id":11,"plan_id":5,"extra_service_id":8,"extraService":{"id":8,"name":"Sincronizar contatos do telefone com PedBot","price":"100","type":3,"seasonality":0,"integration_id":"186008","unit_of_measurement":"por telefone"}},{"id":8,"plan_id":5,"extra_service_id":7,"extraService":{"id":7,"name":"Sincronizar mensagens do telefone com PedBot","price":"100","type":3,"seasonality":0,"integration_id":"186007","unit_of_measurement":"por telefone"}},{"id":3,"plan_id":5,"extra_service_id":5,"extraService":{"id":5,"name":"Chip Extra Direto","price":"50","type":1,"seasonality":12,"integration_id":"185724","unit_of_measurement":"/ano"}},{"id":14,"plan_id":5,"extra_service_id":9,"extraService":{"id":9,"name":"Aquecer chip para campanhas via Whatsapp","price":"100","type":3,"seasonality":0,"integration_id":"186009","unit_of_measurement":"por telefone"}}]},"hasSum":true},"messagePacket":{"showStep":true,"data":{"id":2,"price":"0.01","mode":1,"integration_id":null},"hasSum":false},"extraChips":{"showStep":true,"data":{"id":5,"name":"Chip Extra Direto","price":"50","type":1,"seasonality":12,"integration_id":"185724","unit_of_measurement":"/ano","extraServicePlans":[{"id":3,"plan_id":5,"extra_service_id":5}],"quantity":2},"hasSum":true,"unit":"mês"},"campaignCuration":{"showStep":true,"data":{"id":13,"name":"Curadoria de Disparos","price":"100","type":2,"seasonality":12,"integration_id":"186505","unit_of_measurement":"/ano","extraServicePlans":[{"id":20,"plan_id":5,"extra_service_id":13}]},"hasSum":true,"unit":"mês"},"extraServices":{"showStep":false,"data":[{"id":7,"name":"Sincronizar mensagens do telefone com PedBot","price":"100","type":3,"seasonality":0,"integration_id":"186007","unit_of_measurement":"por telefone","extraServicePlans":[{"id":8,"plan_id":5,"extra_service_id":7}],"quantity":1},{"id":8,"name":"Sincronizar contatos do telefone com PedBot","price":"100","type":3,"seasonality":0,"integration_id":"186008","unit_of_measurement":"por telefone","extraServicePlans":[{"id":11,"plan_id":5,"extra_service_id":8}],"quantity":1},{"id":9,"name":"Aquecer chip para campanhas via Whatsapp","price":"100","type":3,"seasonality":0,"integration_id":"186009","unit_of_measurement":"por telefone","extraServicePlans":[{"id":14,"plan_id":5,"extra_service_id":9}],"quantity":1}],"hasSum":true},"technicalManager":{"showStep":false,"data":{"name":"Daniel dos Santos Andrade","phone_number":"(14) 99770-8584"},"hasSum":false},"legalGuardian":{"showStep":false,"data":{"name":"Daniel dos Santos Andrade","rg_document":"50.657.727-2","cpf_document":"438.620.028-29","phone_number":"(14) 99770-8584","email":"daniel@pedbot.com.br"},"hasSum":false},"company":{"showStep":false,"data":{"social_reason":"Daniel novo teste da plataforma","fantasy_name":"Daniel novo teste da plataforma","cnpj_document":"31.769.846/0001-14","zipcode":"17510-190","street":"Rua Ribeirão Preto","neighbourhood":"São Paulo","city":"Marília","state":"SP","number":"460","additional_details":"bloco 6, apto 635","email":"daniel@pedbot.com.br"},"hasSum":false}}
  //   }
  // },

  methods: {
    nextTab(plusPage = 1) {
      return this.$refs.paymentSteps.nextTab(plusPage)
    },
    previousTab() {
      return this.$refs.paymentSteps.previousTab()
    }
  },

  computed: {
    ...mapStores(useAppStore),
    orderType() {
      const appStore = useAppStore()
      return appStore.orderType
    },
    orderFormData() {
      const appStore = useAppStore()
      return appStore.orderFormData
    }
  }
}
</script>

<style lang="scss">
// Definição de breakpoints
$tablet: 769px;
$desktop: 1024px;

.payment-view {
  overflow-x: hidden;
  width: 100%;
  
  .payment-page-content {
    padding-top: 60px; // Adiciona espaço para a navbar fixa
    overflow-x: hidden;
    width: 100%;
  }
}

// Estilos para garantir que o conteúdo não cause scroll horizontal
.no-overflow {
  overflow-x: hidden;
  max-width: 100%;
}

// Ajustes específicos para a tela de pagamento
.steps-container {
  margin-top: 1rem;
  
  // Ajusta o posicionamento dos elementos nos passos
  .steps-component-payment {
    .steps-marker {
      z-index: 50; // Menor que a navbar
    }
  }
}

// Ajustes para telas específicas
@media screen and (max-width: $tablet) {
  .payment-view {
    .payment-page-content {
      padding-top: 50px; // Menor em telas pequenas
    }
    
    .container {
      padding: 0.75rem;
    }
    
    .column.px-2-mobile {
      padding-left: 0.5rem !important;
      padding-right: 0.5rem !important;
    }
    
    .steps-container {
      margin-top: 0.5rem;
    }
    
    // Ajuste nos campos do formulário
    .field {
      margin-bottom: 1rem;
      
      .label {
        font-size: 1rem !important;
      }
      
      .input {
        font-size: 1rem;
      }
    }
    
    // Ajuste nos botões
    .button.is-medium {
      font-size: 0.9rem;
      padding: 0.5rem 1rem;
      
      .is-size-4 {
        font-size: 1rem !important;
      }
    }
  }
}

// Estilos para prevenir horizontal scrolling em qualquer elemento
* {
  max-width: 100vw;
  box-sizing: border-box;
}
</style>
